/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainEntitiesDocumentsContentType } from './FxIdDomainEntitiesDocumentsContentType';
import {
    instanceOfFxIdDomainEntitiesDocumentsContentType,
    FxIdDomainEntitiesDocumentsContentTypeFromJSON,
    FxIdDomainEntitiesDocumentsContentTypeFromJSONTyped,
    FxIdDomainEntitiesDocumentsContentTypeToJSON,
} from './FxIdDomainEntitiesDocumentsContentType';

/**
 * @type FxIdDomainEntitiesDocumentsDocumentContentContentType
 * Тип содержимого (например, Markdown).
 * @export
 */
export type FxIdDomainEntitiesDocumentsDocumentContentContentType = FxIdDomainEntitiesDocumentsContentType;

export function FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSON(json: any): FxIdDomainEntitiesDocumentsDocumentContentContentType {
    return FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsDocumentContentContentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainEntitiesDocumentsDocumentContentContentType {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainEntitiesDocumentsContentType(json)) {
        return FxIdDomainEntitiesDocumentsContentTypeFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSON(json: any): any {
    return FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSONTyped(json, false);
}

export function FxIdDomainEntitiesDocumentsDocumentContentContentTypeToJSONTyped(value?: FxIdDomainEntitiesDocumentsDocumentContentContentType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainEntitiesDocumentsContentType(value)) {
        return FxIdDomainEntitiesDocumentsContentTypeToJSON(value as FxIdDomainEntitiesDocumentsContentType);
    }

    return {};
}

